import { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking"); // checking | paid | pending | error
  const { clear } = useCart();
  const cleared = useRef(false);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          if (!cleared.current) { clear(); cleared.current = true; }
          return;
        }
      } catch { /* ignore */ }
      if (++tries > 8) { setStatus("pending"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId, clear]);

  return (
    <div data-testid="payment-success-page" className="min-h-[calc(100vh-68px)] flex items-center justify-center px-6">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="text-center max-w-md">
        {status === "checking" && <Loader2 size={40} className="text-rose animate-spin mx-auto mb-6" />}
        {status === "paid" && <CheckCircle2 size={56} className="text-rose mx-auto mb-6" />}
        <h1 className="font-serif-display font-light text-white text-4xl md:text-5xl tracking-tight">
          {status === "paid" ? "Pedido Confirmado!" : status === "checking" ? "Confirmando pagamento..." : status === "pending" ? "Pagamento em processamento" : "Sessão não encontrada"}
        </h1>
        <p className="text-white/50 font-light mt-4">
          {status === "paid" ? "Obrigada pela sua compra na Donna Nara. Você receberá o código de rastreamento após o despacho do pedido." :
           status === "pending" ? "Assim que confirmado, você receberá a atualização. Isso pode levar alguns instantes." :
           status === "checking" ? "Aguarde um momento." : "Não localizamos essa transação."}
        </p>
        <Link to="/loja" className="inline-block mt-10 bg-rose hover:bg-rose-hover text-ink font-bold px-8 py-4 label-caps transition-colors duration-300">Continuar Comprando</Link>
      </motion.div>
    </div>
  );
}
